import { GET_LIVECLASS_PACKAGES, GET_VENDORS } from "utils/graphql/services/live-classes/queries";
import * as Yup from "yup";

export type GroupPackageSubscribersFilter = {
  nlearn3LiveclassPackageId: string;
  admissionNumber: string;
  isArchived: string;
  created_at: [Date | null, Date | null];
  updated_at: [Date | null, Date | null];
};

export const initialValues: GroupPackageSubscribersFilter = {
  nlearn3LiveclassPackageId: "",
  admissionNumber: "",
  isArchived: "",
  created_at: [null, null],
  updated_at: [null, null],
};

export const validationSchema = Yup.object().shape({
  created_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
  updated_at: Yup.array()
    .of(Yup.date().nullable())
    .test("is-range-complete", "End date is required", (value) => {
      if (!value) return true;
      const [start, end] = value;
      if (start && !end) return false;
      return true;
    }),
});

export const properties = [


  {
    id: "nlearn3LiveclassPackageId",
    type: "single-select-search",
    label: "Liveclass Package",
    // list: "nl3_liveclass_packages_gq",
    keyValue: { label: "name", value: "id" },
    query: GET_LIVECLASS_PACKAGES,
    gqlKey: "getLiveclassPackages",
    dataKey: "liveclassPackages",
    searchFieldKey: "searchName",
    className: "name-styles",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "admissionNumber",
    type: "text",
    label: "Admission Number",
    Placeholder: "Enter Admission Number",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: false,
  },
  {
    id: "isArchived",
    type: "normal-select",
    label: "Is Archived",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    options: [
      { label: "True", value: "true" },
      { label: "False", value: "false" },
    ],
    hideNone: false,
    required: false,
  },
  {
    id: "created_at",
    type: "date-range-picker",
    label: "Created Between",
    Placeholder: "Select Created Date Range",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
  {
    id: "updated_at",
    type: "date-range-picker",
    label: "Updated Between",
    Placeholder: "Select Updated Date Range",
    breakpoints: { xs: 12, sm: 6, md: 6, lg: 3 },
    required: false,
  },
];

export function hasAtLeastOneValue(obj: any, keys: string[]) {
  return keys.some((key) => {
    const value = obj[key];
    return (
      value !== "" &&
      value !== null &&
      value !== undefined &&
      !(Array.isArray(value) && value.length === 0) &&
      !(Array.isArray(value) && value.every(v => v === null))
    );
  });
}
